import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Moment from 'moment';
import "moment/locale/ko";
import UserSelectModal from "../common/UserSelectModal";
import PartnerUserSelectModal from "../common/PartnerUserSelectModal";

let newFileID = 1;
let realFiles = [];
let tmpRealFiles = [];

function ClaimInfoUpdateModal({ title, id, onClose, handleView, originData, originRows, MenuUpdateYN }) {
  const appStore = useContext(AppContext);
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [tabID, setTabID] = useState('1');
  
  const [fileRows, setFileRows] = useState([]);
  const [originFileRows, setOriginFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);

  // 담당자 및 거래처 선택 모달 상태 관리
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [isSelectPartnerModalOpen, setSelectPartnerModalOpen] = useState(false);
  const [selectUserTarget, setSelectUserTarget] = useState(''); 
  const [selectmodalTitle, setSelectModalTitle] = useState('');

  const [inputs, setInputs] = useState({
    claim_id: '',
    claim_date: appStore.YYYY_MM_DD(),
    claim_title: '',
    claim_text: '',
    claim_action_date: '',
    claim_action_text: '',
    claim_partner_id: 0,
    claim_partner_name: '',
    claim_user_id: 0,
    claim_user_name: '',
    claim_action_user_id: 0,
    claim_action_user_name: ''
  });

  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y');
  
  const handleSetting = () => {
    setFileColumns([
      {
        field: 'actions', headerName: '동작', width: 55, type:'actions', disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
        ], headerAlign: 'center', align:'center'
      },
      {
        field: 'download', headerName: '다운로드', width: 90, type:'actions', disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ], headerAlign: 'center', align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);
  };

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false, file_name_sever: false, file_name: true, file_type_name: true,
    file_size_dp: true, reg_user_name: true, reg_datetime: true,
    actions: updateFlag, download: true, row_type: false, update_type: false
  });

  useEffect(() => {
    realFiles = [];
    tmpRealFiles = [];
    handleSetting();
    if (tabPanelRef.current) {
        setTabPanelHeight(tabPanelRef.current.clientHeight);
    }
  }, []);
  
  useEffect(() => {
    if (originData) {
      setInputs({
        claim_id: originData.claim_id || '',
        claim_date: originData.claim_date || '',
        claim_title: originData.claim_title || '',
        claim_text: originData.claim_text || '',
        claim_action_date: originData.claim_action_date || '',
        claim_action_text: originData.claim_action_text || '',
        claim_partner_id: originData.claim_partner_id || 0,
        claim_partner_name: originData.claim_partner_name || '',
        claim_user_id: originData.claim_user_id || 0,
        claim_user_name: originData.claim_user_name || '',
        claim_action_user_id: originData.claim_action_user_id || 0,
        claim_action_user_name: originData.claim_action_user_name || ''
      });

      if (originRows && originRows.length > 0) {
        let fileData = originRows.filter((item, index) => {
          return item.claim_file_id && originRows.findIndex(item2 => item.claim_file_id === item2.claim_file_id) === index;
        });

        const mappedFiles = fileData.map((item) => ({
          id: item.claim_file_id,
          file_name_sever: item.claim_file_name_sever,
          file_size: item.claim_file_size,
          file_type: item.claim_file_type,
          file_extension: item.claim_file_extension,
          file_name: item.claim_file_name,
          file_type_name: item.claim_file_type_name,
          file_size_dp: item.claim_file_size_dp,
          reg_user_name: item.claim_file_user_name,
          reg_datetime: Moment(item.claim_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
          row_type: 'O',
          update_type: 'N'
        }));
        
        setFileRows(mappedFiles);
        setOriginFileRows(mappedFiles);
        mappedFiles.forEach(item => newFileID = (item.id >= newFileID) ? item.id + 1 : newFileID);
      }
    }
  }, [originData, originRows]);

  useEffect(() => {
    var array = [];
    for(var i=0; i<originFileRows.length; i++){
      var tmpYN = 'N'
      for(var j=0; j<fileRows.length; j++){
        if(fileRows[j].id === originFileRows[i].id && fileRows[j].file_name_sever === originFileRows[i].file_name_sever){ tmpYN = 'Y' }
      }
      if(tmpYN === 'N'){
        array.push({ ...originFileRows[i], row_type:'O', update_type: 'D' });
      }
    }

    for(var i=0; i<fileRows.length; i++){
      var tmpYN = 'N'
      for(var j=0; j<originFileRows.length; j++){
        if(originFileRows[j].id === fileRows[i].id && originFileRows[j].file_name_sever === fileRows[i].file_name_sever){ tmpYN = 'Y' }
      }
      if(tmpYN === 'N' && (fileRows[i].row_type !== 'A' || fileRows[i].update_type !== 'N')){
        array.push({ ...fileRows[i], row_type:'A', update_type: 'U' });
      }
    }
    setUpdateFileRows(array);
    
    let ADD_YN = 'Y'
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N' && i === (fileRows.length-1)){
        ADD_YN = 'N'
      }else if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        setFileRows((fileRows) => fileRows.filter((data) => data.id !== fileRows[i].id));
        ADD_YN = 'N'
      }
    }
    
    if(ADD_YN === 'Y' && updateFlag){
      newFileID = Number(newFileID) + 1;
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(newFileID), file_name_sever: '', file_size: 0, file_type: '', file_extension: '',
        file_name: '', file_type_name: '', file_size_dp: '', reg_user_name: '', reg_datetime: '',
        row_type:'A', update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const handleTabID = (event, newTabID) => { setTabID(newTabID); };

  // 클릭 이벤트 핸들러
  const onClickPartner = () => {
    setSelectModalTitle('거래처 목록');
    setSelectPartnerModalOpen(true);
  };

  const onClickClaimUser = () => {
    setSelectUserTarget('claim');
    setSelectModalTitle('클레임 담당자 목록');
    setSelectUserModalOpen(true);
  };

  const onClickActionUser = () => {
    setSelectUserTarget('action');
    setSelectModalTitle('조치 담당자 목록');
    setSelectUserModalOpen(true);
  };

  // 모달 콜백 핸들러
  const handlePartnerUserClick = (object) => {
    setInputs({ ...inputs, claim_partner_id: object.id, claim_partner_name: object.partner_name });
    setSelectPartnerModalOpen(false);
  };

  const handleUserClick = (object) => {
    if (selectUserTarget === 'claim') {
      setInputs({ ...inputs, claim_user_id: object.id, claim_user_name: object.user_name });
    } else if (selectUserTarget === 'action') {
      setInputs({ ...inputs, claim_action_user_id: object.id, claim_action_user_name: object.user_name });
    }
    setSelectUserModalOpen(false);
  };

  const fileAddClick = (object) => {
    const input = document.createElement('input');
    input.type = "file";
    input.multiple = true;
    input.click();
    input.onchange = () => {
      tmpRealFiles = [];
      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
        tmpRealFiles.push(input.files[i]);
      }
      var array = [];
      for(var i=0; i<tmpRealFiles.length; i++){
        var tmp_sever_file_name = tmpRealFiles[i].name;
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1);
        newFileID = Number(newFileID) + 1;
        array.push({
          id: Number(newFileID),
          file_name_sever: tmp_sever_file_name,
          file_size: tmpRealFiles[i].size,
          file_type: tmpRealFiles[i].type,
          file_extension: tmp_file_extension,
          file_type_name: appStore.convertFileTypeName(tmpRealFiles[i].type),
          file_name: tmp_sever_file_name,
          file_size_dp: appStore.convertFileSize(tmpRealFiles[i].size),
          reg_user_name: '', reg_datetime: '', row_type:'A', update_type: 'U'
        });
      }
      setFileRows((fileRows) => [...fileRows, ...array]);
    };
  };

  const fileDeleteClick = (object) => {
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }
    if(object.row.row_type === 'O'){
      setUpdateFileRows(prevRows => prevRows.some(r => r.id === object.row.id && r.update_type === 'D') ? prevRows : [...prevRows, { ...object.row, row_type: 'O', update_type: 'D' }]);
    }else{
      setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    }
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({ fileName: object.row.file_name, fileNameSever: object.row.file_name_sever }),
    { withCredentials: true, responseType: 'blob' })
    .then(function (response) {
        if(response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", object.row.file_name);
          document.body.appendChild(link);
          link.click();
        }
    });
  };

  const handleSave = (event) => {
    let msg = '';
    if (inputs.claim_date === '') msg = '클레임일자는 필수로 작성해주세요.';
    else if (inputs.claim_title === '') msg = '제목은 필수로 작성해주세요.';
    else if (!inputs.claim_partner_id || String(inputs.claim_partner_id) === '0') msg = '거래처는 필수로 선택해주세요.';
    else if (!inputs.claim_user_id || String(inputs.claim_user_id) === '0') msg = '클레임담당자는 필수로 선택해주세요.';

    if (msg !== '') {
      Swal.fire({ title: '<p style="color:red">작성 오류</p>', html: msg, confirmButtonText: '확인' });
    } else {
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/ClaimInfo/Save", { inputs }, { withCredentials: true })
      .then(function (response) {
        if (response.status === 200) {
          const selectID = response.data || inputs.claim_id;

          if (updateFileRows.length > 0) {
            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'Claim');
            formData.append('type', inputs.claim_id ? 'Update' : 'Reg');
            formData.append('updateFileRows', JSON.stringify(updateFileRows));

            for (let i = 0; i < realFiles.length; i++) { formData.append('files', realFiles[i]); }

            axios.post('/api/SaveCommon/GridFileSave', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((res) => {
              if (res.status === 200) {
                Swal.fire({ title: '저장 완료', text: '정상적으로 저장되었습니다.', confirmButtonText: '확인', timer: 5000, timerProgressBar: true })
                .then(() => { handleView(); onClose?.(); });
              } else {
                appStore.capture();
              }
            })
            .catch((error) => { appStore.capture(); }); 
          } else {
            Swal.fire({ title: '저장 완료', text: '정상적으로 저장되었습니다.', confirmButtonText: '확인', timer: 5000, timerProgressBar: true })
            .then(() => { handleView(); onClose?.(); });
          }
        } else {
          appStore.capture();
        }
      })
      .catch(function (error) { appStore.capture(); })
      .finally(() => appStore.setLoading(false));
    }
  };

  return (
    <PCModal onClose={onClose} title={title}>
      <div className="modal" style={{ height: 'auto', overflowY: 'auto' }}>
        <TabContext value={tabID}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
              <Tab label="클레임 정보" value="1" />
              <Tab label="첨부 파일" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1" ref={tabPanelRef}>
            <table className="ModalTABLE">
              <tbody>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">제목<span className="essential">*</span></div>
                      <div className="modal_filed_input" style={{ display: 'flex', width: '768px' }}>
                        <input type="text" placeholder="제목" value={inputs.claim_title} name="claim_title" onChange={onChange} autoComplete="off" style={{ width: '100%' }} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">클레임일자<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <input type="date" value={inputs.claim_date} name="claim_date" onChange={onChange} autoComplete="off" />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">클레임담당자<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="클레임 담당자" value={inputs.claim_user_name} name="claim_user_name" onClick={onClickClaimUser} style={{ backgroundColor: '#EFEFEF4D', cursor: 'pointer' }} readOnly autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">거래처<span className="essential">*</span></div>
                      <div className="modal_filed_input" style={{ display: 'flex', width: '768px' }}>
                        <input type="text" placeholder="거래처" value={inputs.claim_partner_name} name="claim_partner_name" onClick={onClickPartner} style={{ backgroundColor: '#EFEFEF4D', cursor: 'pointer', width: '100%' }} readOnly autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">상세내용</div>
                      <div className="modal_filed_input">
                        <textarea placeholder="클레임 상세내용" value={inputs.claim_text} name="claim_text" onChange={onChange} style={{ width: '768px', height: '110px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', resize:'none' }} autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">조치일자</div>
                      <div className="modal_filed_input">
                        <input type="date" value={inputs.claim_action_date} name="claim_action_date" onChange={onChange} autoComplete="off" />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">조치담당자</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="조치 담당자" value={inputs.claim_action_user_name} name="claim_action_user_name" onClick={onClickActionUser} style={{ backgroundColor: '#EFEFEF4D', cursor: 'pointer' }} readOnly autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">조치사항</div>
                      <div className="modal_filed_input">
                        <textarea placeholder="조치사항 내용" value={inputs.claim_action_text} name="claim_action_text" onChange={onChange} style={{ width: '768px', height: '110px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', resize:'none' }} autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </TabPanel>
          <TabPanel value="2" style={{ height: tabPanelHeight }}>
            <div className="modal_grid">
              <DataGrid
                rows={fileRows}
                columns={fileColumns}
                columnVisibilityModel={fileColumnVisibilityModel}
                editMode='cell'
                AlternatingRowBackground="LavenderBlush"
                rowsPerPageOptions={[20, 50, 100]}
                initialState={{ density: 'compact' }}
                slots={{ noRowsOverlay: GridNoRow }}
                disableColumnSorting 
              />
            </div>
          </TabPanel>
        </TabContext>
        <table className="ModalTABLE">
          <tbody>
            <tr>
              <td className="ModalTD" colSpan={2}>
                <div className="modal_action">
                  <div className="modal_button">
                    <Button onClick={() => { onClose?.(); }} className="btn-p" sx={{ m: 1, fontSize: 18, color: "white", borderColor: "#808080", backgroundColor: "#808080", ":hover": { backgroundColor: "#808080" } }} variant="outlined">
                      닫기
                    </Button>
                  </div>
                  <div className="modal_button">
                    {updateFlag && (
                      <Button onClick={handleSave} className="btn-p btn-u" sx={{ m: 1, fontSize: 18, color: "white", borderColor: "#FF3636", backgroundColor: "#FF3636", ":hover": { backgroundColor: "#FF3636" } }} variant="outlined">
                        저장
                      </Button>
                    )}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {isSelectUserModalOpen && (
        <UserSelectModal
          onClose={() => setSelectUserModalOpen(false)}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
        />
      )}
      
      {isSelectPartnerModalOpen && (
        <PartnerUserSelectModal
          onClose={() => setSelectPartnerModalOpen(false)}
          title={selectmodalTitle}
          handlePartnerUserClick={handlePartnerUserClick}
        />
      )}
    </PCModal>
  );
}

export default ClaimInfoUpdateModal;